import { personInfoFrag } from './person.common-type';

export const folderInfoFrag = `
    id
    person {
        ${personInfoFrag}
    }
`;
